window.app.factory("attributeUtils", [
  "$q",
  "$rootScope",
  function($q, $rootScope) {
    return {
      hasAtLeastOne,
      isArticleSuperUser
    };

    function hasAtLeastOne(which, where) {
      where = where || $rootScope.userdata.userAttributes;
      return which.some(
        qAttr => !!where.find(attr => attr.attribute === qAttr.attribute)
      );
    }

    // Check the super user attribute based on config
    function isArticleSuperUser(config = {}) {
      const { superUserAttribute } = config;

      return superUserAttribute && hasAtLeastOne([superUserAttribute]);
    }
  }
]);



// WEBPACK FOOTER //
// ./src/services/attributeUtils.js